import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import { handleExecuteResponse } from 'epic/workspace/ordersBasket/orderOperations/common/orderOperations.helper';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { of, throwError } from 'rxjs';
import { catchError, filter, map, mergeMap, take } from 'rxjs/operators';
import { ordersBasketFormTradeTimeout } from 'state/orders-basket/actions';
import type { OrdersBasketTradeResponse } from 'state/orders-basket/models';
import { ordersBasketFormTradeFailedThunk } from 'state/orders-basket/thunks';
import type { EpicWithThunk } from 'state/state.common';
import { throwOnTimeout } from 'utils/rxjs';
import { fatEventApiConnector } from 'utils/streaming/api';
import { tradeExecutionReport } from 'utils/streaming/messages';

export function tradeResultReceivedForBookingEpic(appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, _, { oldHttpClient, getSgmeConfiguration, frontLogger, streaming }) =>
    actions$.pipe(
      ofType('BOOKING_ACKED'),
      filter(action => action.workspace === 'ordersBasket'),
      mergeMap(({ formId, quoteId }) => {
        const timeoutMs = getSgmeConfiguration().tradeExecReportTimeoutMs;

        return tradeExecutionReport(streaming).pipe(
          filter(event => event.quoteId === quoteId),
          mergeMap(lightEvent =>
            fatEventApiConnector(oldHttpClient)
              .getFatEvent<OrdersBasketTradeResponse>(lightEvent)
              .pipe(
                map(tradeResponse => handleExecuteResponse(formId, tradeResponse, true)),
                catchError((error: Error) =>
                  throwError(new apiErrorHelper.EpicApiError(apiErrorHelper.defaultTechnicalErrorKey, error)),
                ),
              ),
          ),
          take(1),
          throwOnTimeout(
            timeoutMs,
            new apiErrorHelper.TimeoutError(timeoutMs, 'trade.errorMessages.executionReportTimeout'),
            appScheduler,
          ),
          catchError((error: Error) => {
            frontLogger.error('An error occurred inside tradeResultReceivedEpic {@FrontError}', error);
            if (error.name === 'TimeoutError') {
              return of(ordersBasketFormTradeTimeout(formId));
            }
            return of(ordersBasketFormTradeFailedThunk(formId, apiErrorHelper.toApiErrorMessage(error)));
          }),
        );
      }),
    );
}
